<template>
  <div
    class="navbar-item"
    v-if="!is_added && $router.currentRoute.name !== 'how-to-add'"
  >
    <span class="control button-navbar">
      <a
        class="button is-primary button-navbar button-ats"
        href="/app/how-to-add"
        aria-label="Add to Slack"
      >
        <span class="icon">
          <i class="fas fa-plus"></i>
        </span>
        <span>Add to Slack</span>
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: "add-to-slack-button",
  data() {
    return {
      is_added: localStorage.getItem("is-added") == "true"
    };
  }
};
</script>

<style scoped>
.button-ats {
  padding: 15px;
  background-color: #fc636b;
  color: white;
}

.button-ats:hover {
  background-color: #fa4d5c;
  color: white;
}
</style>
